import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import PositionRateSettingsShowActions from '../shared/position-rate-settings-show/PositionRateSettingsShowActions';
import PositionRateSettingsShow from '../shared/position-rate-settings-show/PositionRateSettingsShow';
import { generatePositionalRateSettingsShowViewQuery } from '../utils/generatePositionalRateSettingsQuery';

const StateLocationTypePositionRateSettingShow = () => {
  return (
    <Show actions={<PositionRateSettingsShowActions />}>
      <PositionRateSettingsShow />
    </Show>
  );
};

StateLocationTypePositionRateSettingShow.query = gql(
  generatePositionalRateSettingsShowViewQuery('state_location_type_position_rate_setting'),
);

export default StateLocationTypePositionRateSettingShow;
